import { render, staticRenderFns } from "./EditarArmaDialogComponent.vue?vue&type=template&id=6f061b45&scoped=true"
import script from "./EditarArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarArmaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarArmaDialogComponent.vue?vue&type=style&index=0&id=6f061b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f061b45",
  null
  
)

export default component.exports